import PropTypes from 'prop-types';
import React from 'react';
import { createPortal } from 'react-dom';
import TransitionWrapper from 'root/components/molecules/TransitionWrapper';

import Drawer from './drawer';

const modalRoot = document.getElementById('modals');

const DrawerPortal = ({ active, ...props }) =>
  createPortal(
    <TransitionWrapper
      component={Drawer}
      passedProps={{ ...props }}
      visible={active}
    />,
    modalRoot,
  );

DrawerPortal.propTypes = {
  active: PropTypes.bool.isRequired,
};

export default DrawerPortal;
